module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_5.c4cb6a47.png";